//core
import React from "react";
import {
  Card,
  Typography
} from "@mui/material";

//styles
import { useStyles } from "./styles";

//icon
import { NoDataIcon } from "../../UI/Icons";

interface IErrorDataProps {
  title: string;
  text?: string;
  elevation?: number
}

const ErrorData = (props: IErrorDataProps) => {
  const styles = useStyles();

  const {
    title,
    text,
    elevation = 2,
  } = props;

  return (
    <Card className={styles.card} elevation={elevation}>
      <NoDataIcon className={styles.img} />
      <Typography sx={{mb: 1}} variant="h6" component="div">{title}</Typography>
      {
        text && <Typography className={styles.text} variant="body2" component="p">{text}</Typography>
      }
    </Card>
  );
};

export default ErrorData;
